import { request } from "../../utils/request";

export interface PointsSummaryResponse {
  code: number;
  data: {
    totalPoints: number;      // 总积分
    availablePoints: number;  // 可用积分
    usedPoints: number;       // 已用积分
    lastCalcTime: string;     // 最后查询时间
  };
  msg: string;
}

// 获取积分汇总信息（头部导航栏展示）
export const getPointsSummaryApi = () => {
  return request<PointsSummaryResponse>("/video/points", {
    method: "GET",
  });
};

export interface PointsIncomeRecord {
  pointsIncome: number;
  pointType: number;
  source: number;
  createTime: string;
  expireTime: string;
  status: number;
}

export interface PointsIncomeResponse {
  code: number;
  data: {
    list: PointsIncomeRecord[];
    total: number;
  };
  msg: string;
}

// 获取积分获取明细（积分明细弹窗-积分获取tab）
export const getPointsIncomeRecordsApi = (params: {
  pageNo: number;
  pageSize: number;
  status?: number;
  sort?: number;
}) => {
  return request<PointsIncomeResponse>("/video/points/income/records", {
    method: "GET",
    params,
  });
};

export interface PointsExpenditureRecord {
  expenditurePoints: number;
  functionType: number;
  taskName: string | null;
  duration: number | null;
  createTime: string;
  serialId: string;
  status: number;
}

export interface PointsExpenditureResponse {
  code: number;
  data: {
    list: PointsExpenditureRecord[];
    total: number;
  };
  msg: string;
}

// 获取积分消耗明细（积分明细弹窗-积分消耗tab）
export const getPointsExpenditureRecordsApi = (params: {
  pageNo: number;
  pageSize: number;
  status?: number;
  sort?: number;
}) => {
  return request<PointsExpenditureResponse>("/video/points/expenditure/records", {
    method: "GET",
    params,
  });
};




